import { appendDataToListTable, renderListError } from '../crud/shared.js';
import { PageTitle } from '../../components.js';
import { Page } from '../base.js';

class AuthListRow {
  static props = ['href', 'name', 'domain', 'createdAt', 'userEmail'];
  static timl = `
    td
      a[href="{{ Props.href }}"] {{ Props.name }}
    td.pr-4 {{ Props.domain }}
    td.table-col-100.pr-4[style="white-space:nowrap;"] {{ Props.createdAt }}
    td.table-col-100 {{ Props.userEmail }}
  `;
}

export class AuthList extends Page {
  static timlComponents = {
    PageTitle
  };

  static timl = `
    a.list-view-add-button.create-button[href="/auth/create"] Add app
    <PageTitle title="Authentication">
    table.resource-table[data-empty-title="No authentication apps yet" data-empty-description="Add an authentication app to manage sign-in and registration." data-empty-action="Add app" data-empty-href="/auth/create"]
      thead
        th Name
        th.pr-4 Domain
        th.table-col-100.pr-4 Created At
        th.table-col-100 Created By
      tbody#auth-config-rows.fade
  `;

  static javascript() {
    API.get(API.resourceUrl('authConfigs'))
      .then(response => {
        appendDataToListTable('#auth-config-rows', response.data, AuthListRow, this.mapItemToRowData);
      })
      .catch(error => renderListError('#auth-config-rows', error, 'Authentication'));
  }

  static mapItemToRowData(item) {
    return {
      href: `${location.href}/${item.id}#${item.name}`,
      name: item.name,
      domain: item.domain || '',
      createdAt: Util.formatDate(item.createdAt),
      userEmail: item.createdBy || ''
    };
  }
}
